import React from 'react';
import {Checkbox, FormField} from "semantic-ui-react";
import Info from "../../../components/Info";
import NumberInput from "../../../controls/numberInput";

const PalletsForm = ({changeParam, form, errors}) => {
    return <div className={`d-flex inputs`}>
        <FormField error={errors['palletsCount']}>
            <label>Кол-во паллет*</label>
            <NumberInput
                id="palletsCount"
                value={form.palletsCount}
                decimals="0"
                min="0"
                onChange={value => changeParam("palletsCount", value)}
            />
        </FormField>
        <FormField error={errors['palletsWeight']}>
            <label>Общий вес, кг*</label>
            <NumberInput
                id="palletsWeight"
                value={form.palletsWeight}
                decimals="5"
                min="0"
                onChange={value => changeParam("palletsWeight", value)}
            />
        </FormField>
        <FormField error={errors['palletsVolume']}>
            <label>Объем места, м3*</label>
            <NumberInput
                id="palletsVolume"
                value={form.palletsVolume}
                decimals="5"
                min="0"
                onChange={value => changeParam("palletsVolume", value)}
            />
        </FormField>
    </div>
}

export default PalletsForm;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/palletsForm.jsx